import { DataProvider } from '@repo/ui/dataProvider'

import { Members } from '@/components/admin/members/Members'
import { SkeletonCard } from '@/components/skeletons/SkeletonCard'
import { RootState } from '@/store'

export function MembersRoute() {
  return (
    <DataProvider
      loadingComponent={<SkeletonCard />}
      selectors={[(state: RootState) => state.admin.caseWorkers]}
      render={(caseWorkers) => <Members caseWorkers={caseWorkers} />}
    />
  )
}
